<div class="sidebar-outer">
  <a class="logo d-flex align-items-center" >
    <span class="start" >MyTask</span>
    <!--<img src="assets/img/app/VechicleLogo.PNG" style="width:100px;margin-left: 41px;" />-->
  </a>
    <app-vertical-menu [menuItems]="menuItems"></app-vertical-menu>    
</div>
